/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ---------------------------------------------------------------------------
   Inclusive-VAT price display
   ---------------------------------------------------------------------------
   Prices in this store are entered and shown excluding VAT. The "ex VAT" label
   itself is applied in CSS (see snippets/css-include.liquid) so that it cannot
   be lost; this adds the calculated inclusive figure alongside it, e.g.

       £116.00 ex VAT (£139.20 inc VAT)

   It re-runs after any variant change because the theme rebuilds .price__number
   with innerHTML in VariantSelects.renderProductInfo() and ProductCard.render(),
   which discards anything added to that element beforehand.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var VAT_RATE = 0.2; // UK standard rate
  var MARKER = 'price__inc-vat';

  function currency() {
    try {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    } catch (e) {
      return 'GBP';
    }
  }

  // "£1,234.56" / "1.234,56 €" -> 1234.56, or null if it cannot be read confidently.
  function parseAmount(text) {
    if (!text) return null;
    var s = String(text).replace(/\s|&nbsp;/g, '');
    var digits = s.replace(/[^0-9.,]/g, '');
    if (!digits) return null;
    var lastDot = digits.lastIndexOf('.');
    var lastComma = digits.lastIndexOf(',');
    var sep = Math.max(lastDot, lastComma);
    var whole, frac = '';
    if (sep > -1 && digits.length - sep - 1 <= 2) {
      whole = digits.slice(0, sep);
      frac = digits.slice(sep + 1);
    } else {
      whole = digits;
    }
    whole = whole.replace(/[.,]/g, '');
    if (!whole && !frac) return null;
    var value = parseFloat((whole || '0') + '.' + (frac || '0'));
    return isFinite(value) ? value : null;
  }

  function format(amount) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency()
      }).format(amount);
    } catch (e) {
      return '£' + amount.toFixed(2);
    }
  }

  function decorate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var numbers = scope.querySelectorAll('.price__number');
    for (var i = 0; i < numbers.length; i++) {
      var number = numbers[i];
      if (number.querySelector('.' + MARKER)) continue; // already done
      var money = number.querySelector('.money');
      if (!money) continue;

      var ex = parseAmount(money.textContent);
      if (ex === null || ex <= 0) continue; // "From", price ranges, empty states

      var span = document.createElement('span');
      span.className = MARKER;
      span.textContent = ' (' + format(ex * (1 + VAT_RATE)) + ' inc VAT)';
      number.appendChild(span);
    }
  }

  var pending = false;
  function schedule(root) {
    // Run after the theme's own innerHTML rewrite has landed, coalescing bursts.
    if (pending) return;
    pending = true;
    // setTimeout, not requestAnimationFrame: rAF does not fire while the tab is
    // in the background, which would leave `pending` stuck true and silently
    // stop every later update. The try/finally guarantees the flag is cleared
    // even if decorate throws.
    setTimeout(function () {
      try {
        decorate(root);
      } catch (e) {
        /* a price label must never break the page */
      } finally {
        pending = false;
      }
    }, 0);
  }

  function init() {
    decorate(document);

    // The theme fires this on <variant-selects>/<variant-radios>; it does not bubble,
    // so listen in the capture phase from the document instead of binding each element.
    document.addEventListener('on:variant:change', function (e) { schedule(e.target.closest('section') || document); }, true);

    // Belt and braces: any change inside a product form, and cards rendered later.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form, variant-selects, variant-radios, variant-mixed-inputs, quick-shop')) {
        schedule(document);
      }
    }, true);

    if ('MutationObserver' in window) {
      new MutationObserver(function () { schedule(document); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
